import * as React from "react";
const SvgAngleDown3 = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 6L8 10L12 6", stroke: "#1D1F20", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgAngleDown3;
